import React, { useState } from 'react';
import styles from './index.module.css';
import { Logo, Twitter, Facebook, Instagram } from '../../assets';
import { Sparkels } from '../../Components';
import GlowButton from '../../Components/GlowButton';

const Footer = (props) => {
  const [mail, setMail] = useState('');

  return (
    <footer className={styles.footer}>
      {/* Main Footer Content */}
      <div className={styles.footerContent}>
        <div className={styles.container}>
          {/* Brand Section */}
          <div className={styles.brandSection}>
            <div className={styles.logoContainer}>
              <img src={Logo} width={60} height={60} alt="Chessmind Logo" className={styles.logo}/>
              <h3 className={styles.brandName}>Chessmind</h3>
            </div>
            <p className={styles.brandDescription}>
              Your ultimate chess platform for analysis, learning, and improvement. 
              Master the game with advanced tools and insights.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://x.com/Chessmindio" className={styles.socialLink} aria-label="Twitter">
                <Twitter />
              </a>
              {/*<a href="#" className={styles.facebook} aria-label="Facebook">
                <Facebook />
              </a>*/}
              <a href="https://www.instagram.com/chessmind.io/" className={styles.socialLink} aria-label="Instagram">
                <Instagram />
              </a>
            </div>
          </div>

          {/* Quick Links Section */}
          <div className={styles.linksSection}>
            <div className={styles.sectionHeader}>
              <h4 className={styles.sectionTitle}>Quick Links</h4>
            </div>
            <nav className={styles.linksList}>
              <a href='https://analysis.chessmind.io' className={styles.footerLink}>
                <span className={styles.linkIcon}>⚡</span>
                Analysis Board
              </a>
              <a href='/pricing' className={styles.footerLink}>
                <span className={styles.linkIcon}>💰</span>
                Pricing
              </a>
              <a href='/contact' className={styles.footerLink}>
                <span className={styles.linkIcon}>📧</span>
                Contact
              </a>
              <a href='/privacy' className={styles.footerLink}>
                <span className={styles.linkIcon}>🔒</span>
                Privacy Policy
              </a>
              <a href='/terms' className={styles.footerLink}>
                <span className={styles.linkIcon}>📋</span>
                Terms of Use
              </a>
              <a href='/cookies' className={styles.footerLink}>
                <span className={styles.linkIcon}>🍪</span>
                Cookie Policy
              </a>
            </nav>
          </div>

          {/* Newsletter Section */}
          {props.width > 800 && (
            <div className={styles.newsletterSection}>
              <div className={styles.sectionHeader}>
                <h4 className={styles.sectionTitle}>Get Started</h4>
                <div className={styles.gradientLine}></div>
              </div>
              <p className={styles.newsletterDescription}>
                Join thousands of chess players improving their game with Chessmind.
              </p>
              <div className={styles.emailForm}>
                <div className={styles.inputWrapper}>
                  <input
                    type="email"
                    value={mail}
                    onChange={(e) => setMail(e.target.value)}
                    className={styles.emailInput}
                    placeholder="Enter your email"
                    aria-label="Email address"
                  />
                  <div className={styles.inputGlow}></div>
                </div>
                <div className={styles.buttonWrapper}>
                  <div className={styles.buttonGlow}></div>
                  <GlowButton 
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = '/register?mail=' + mail;
                    }} 
                    text="Get Started Free" 
                  />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Footer Bottom */}
      <div className={styles.footerBottom}>
        <div className={styles.container}>
          <div className={styles.bottomContent}>
            <p className={styles.copyright}>
              © 2025 Chessmind. All rights reserved.
            </p>
            <div className={styles.bottomLinks}>
              <a href="/privacy" className={styles.bottomLink}>Privacy</a>
              <a href="/terms" className={styles.bottomLink}>Terms</a>
              <a href="/cookies" className={styles.bottomLink}>Cookies</a>
              <a href="/contact" className={styles.bottomLink}>Support</a>
            </div>
          </div>
        </div>
      </div>

      {/* Background Effects */}
      <div className={styles.backgroundEffects}>
        <div className={styles.gradientOrb1}></div>
        <div className={styles.gradientOrb2}></div>
        <div className={styles.gridPattern}></div>
      </div>
    </footer>
  );
};

export default Footer;
